export const MOBILE_BREAKPOINT = 768

export function isMobileScreenWidth(width) {
  const vw =
    width ??
    Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  return vw < MOBILE_BREAKPOINT
}

export const EXCLUDED_BOTTOM_NAV_ROUTES = [
  'LoginPage',
  'Transaction',
  'PayStarTransaction',
  'ZarinPalTransaction',
  'ParsianTransaction',
  'Verify',
  'CaptchaBox',
  'VerifySafte',
  'DetailUssd',
  'HampaPay',
  'Maintenance',
  'v',
  'L',
]

export function isRouteExcluded(routeName) {
  return EXCLUDED_BOTTOM_NAV_ROUTES.includes(routeName)
}

export function hasAccessMenu(accessMenu, id) {
  if (!accessMenu || !Array.isArray(accessMenu)) return false
  const item = accessMenu.find((x) => x.id == id)
  return !!(item && item.isMenu)
}

function parseAllMenu(allMenuRaw) {
  if (!allMenuRaw || !Array.isArray(allMenuRaw)) return []
  return allMenuRaw.map((element) => {
    const el = { ...element }
    if (el.params != null && typeof el.params === 'string') {
      try {
        const withQuotes = el.params.replace(/(\b[a-z]+:)?(\b[a-z]+\b)/gi, '"$2"')
        const parsed = JSON.parse(withQuotes)
        for (const [key, value] of Object.entries(parsed)) {
          if (value === 'true') parsed[key] = true
          if (value === 'false') parsed[key] = false
        }
        el.params = parsed
      } catch (e) {
        // keep original params
      }
    }
    return el
  })
}

function getMenuChildren(allMenu, parentId) {
  return allMenu.filter((x) => x.parentId == parentId)
}

function pushGroup(flat, title, groupItems, icon = null) {
  if (!groupItems.length) return
  flat.push({ id: 'header-' + title, label: title, isHeader: true, icon: icon || undefined })
  flat.push(
    ...groupItems.map((item) => ({
      ...item,
      isSubMenu: true,
      icon: undefined,
    })),
  )
}

export function buildNetPaFullMenuItems(session, { isWebSiteView = false, allMenuRaw = null } = {}) {
  const allMenu = parseAllMenu(allMenuRaw || session.get('AllMenu') || [])
  const flat = []
  const custCode = session.get('CustCode')

  if (session.get('IsRahbar')) {
    const rahbarItems = [
      { id: 'access', label: 'دسترسی منوها', icon: 'fas fa-key', routeName: 'Accessability' },
      { id: 'gateway', label: 'تنظیمات', icon: 'fas fa-cog', routeName: 'Gateway' },
      { id: 'users-setting', label: 'بررسی وضعیت کاربران', icon: 'fas fa-users-cog', routeName: 'UsersSetting' },
    ]
    if (isWebSiteView) {
      rahbarItems.push({ id: 'website-setting', label: 'تنظیمات سایت', icon: 'fas fa-globe', routeName: 'WebSiteSetting' })
    }
    rahbarItems.push(
      { id: 'manage-files', label: 'مدیریت فایلها', icon: 'fas fa-folder-open', routeName: 'MangeDownloadForms' },
    )
    if (custCode == '801') {
      rahbarItems.push({ id: 'tabloo-admin', label: 'ثبت تابلو اعلانات', icon: 'fas fa-bell', routeName: 'TablooElanat' })
    }
    rahbarItems.push(
      { id: 'setting-vam', label: 'تنظیمات درخواست وام', icon: 'fas fa-sliders-h', routeName: 'SettingVam' },
      { id: 'faq-mgmt', label: 'پرسش و پاسخ‌های متداول', icon: 'fas fa-question-circle', routeName: 'FAQManagement' },
    )
    pushGroup(flat, 'راهبر سیستم', rahbarItems, 'fas fa-user-shield')
  }

  if (session.get('IsRahbar') && (custCode == '932' || custCode == '8002')) {
    pushGroup(flat, 'لیست درخواست‌ها', [
      { id: 'list-vam', label: 'درخواست‌های وام', icon: 'fas fa-file-alt', routeName: 'ListVamRequests' },
      { id: 'list-register', label: 'درخواست‌های عضویت', icon: 'fas fa-user-plus', routeName: 'ListRegisterRequests' },
      { id: 'list-enseraf', label: 'درخواست‌های انصراف', icon: 'fas fa-file', routeName: 'ListRequestLetterEnseraf' },
      { id: 'list-esterdad', label: 'درخواست‌های استرداد سپرده', icon: 'fas fa-file', routeName: 'ListRequestLetterSodorEsterdad' },
      { id: 'list-aghsat', label: 'درخواست‌های تغییر اقساط', icon: 'fas fa-file', routeName: 'ListRequestLetterTaghirAghsat' },
      { id: 'list-modat', label: 'درخواست‌های تغییر مدت سپرده', icon: 'fas fa-file', routeName: 'ListRequestLetterTaghirModatSepordeh' },
      { id: 'list-file', label: 'دریافت فایل', icon: 'fas fa-download', routeName: 'ListAzaFile' },
    ], 'fas fa-list-alt')
  }

  if (session.get('ModirShobe')) {
    const modirItems = [
      { id: 'manage-users', label: 'مدیریت کاربران', icon: 'fas fa-user-shield', routeName: 'ManagUsers' },
    ]
    if (session.get('UserInfoNetPaModirShobe') != null) {
      modirItems.push({ id: 'back-modir', label: 'بازگشت به پنل مدیر', icon: 'fas fa-undo', action: 'gotoModirShobe' })
    }
    if (custCode == '801') {
      modirItems.push(
        { id: 'tabloo-modir', label: 'ثبت تابلو اعلانات', icon: 'fas fa-bell', routeName: 'TablooElanat' },
        { id: 'setting-vam-modir', label: 'تنظیمات درخواست وام', icon: 'fas fa-sliders-h', routeName: 'SettingVam' },
      )
    }
    pushGroup(flat, 'مدیر شعبه', modirItems, 'fas fa-user-tie')
  }

  const parentMenus = allMenu.filter((x) => x.isParentMenu == true)
  parentMenus.forEach((parent) => {
    const children = getMenuChildren(allMenu, parent.id)
    if (!children.length) return
    pushGroup(
      flat,
      parent.name,
      children.map((child) => ({
        id: 'menu-' + child.id,
        label: child.name,
        routeName: child.routeName,
        params: child.params != null ? child.params : undefined,
      })),
      parent.menuIcone || 'fas fa-folder',
    )
  })

  const accessMenu = session.get('AccessMenu') || []
  const extraItems = []
  if (hasAccessMenu(accessMenu, 6)) {
    extraItems.push({ id: 'turnover', label: 'صورت حساب', icon: 'fas fa-receipt', routeName: 'Turnover' })
  }
  if (hasAccessMenu(accessMenu, 13)) {
    extraItems.push({ id: 'debtor', label: 'برداشت از حساب', icon: 'fas fa-arrow-up', routeName: 'Debtor' })
  }
  if (hasAccessMenu(accessMenu, 20)) {
    extraItems.push({ id: 'deposit-group', label: 'پرداخت گروهی', icon: 'fas fa-coins', routeName: 'DepositGroup' })
  }
  if (hasAccessMenu(accessMenu, 82)) {
    extraItems.push({ id: 'tabloo', label: 'تابلو اعلانات', icon: 'fas fa-bell', routeName: 'TablooElanat' })
  }
  extraItems.push({ id: 'cart', label: 'سبد پرداخت', icon: 'fas fa-shopping-bag', routeName: 'Cart' })
  pushGroup(flat, 'سایر', extraItems, 'fas fa-ellipsis-h')

  flat.push({ id: 'logout', label: 'خروج', icon: 'fas fa-sign-out-alt', action: 'logout' })

  return flat
}

export function buildNetPaBottomNavItems(session, { isWebSiteView = false, allMenuRaw = null } = {}) {
  const accessMenu = session.get('AccessMenu') || []
  const items = []

  // RTL: اول آرایه = سمت راست
  if (hasAccessMenu(accessMenu, 9)) {
    items.push({ id: 'loan', label: 'تسهیلات', icon: 'fas fa-gift', routeName: 'loan' })
  }

  if (hasAccessMenu(accessMenu, 5)) {
    items.push({ id: 'accounts', label: 'حساب‌ها', icon: 'fas fa-list', routeName: 'Accounts' })
  }

  items.push({ id: 'home', label: 'پیشخوان', icon: 'fas fa-home', routeName: 'Home' })

  if (hasAccessMenu(accessMenu, 6)) {
    items.push({
      id: 'turnover',
      label: 'صورت حساب',
      icon: 'fas fa-receipt',
      routeName: 'Turnover',
    })
  } else if (hasAccessMenu(accessMenu, 11)) {
    items.push({
      id: 'pay',
      label: 'پرداخت',
      icon: 'fas fa-coins',
      routeName: 'Deposit',
      params: { IsShowComboHesab: true, IsTashilat: true },
      featured: true,
    })
  }

  const fullMenuItems = buildNetPaFullMenuItems(session, { isWebSiteView, allMenuRaw })
  items.push({
    id: 'menu',
    label: 'منو',
    icon: 'fas fa-bars',
    action: 'menu',
    moreItems: fullMenuItems,
  })

  return items
}

export function getCartBadgeCount(store) {
  if (!store || !store.state || !store.state.Netpa_Cart) return 0
  let count = 0
  const cart = store.state.Netpa_Cart
  for (let index = 0; index < cart.length; index++) {
    if (cart[index].item && cart[index].item.length > 0) {
      count += cart[index].item.length
    }
  }
  return count
}
